<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                    <label class="vs-input--label">{{ $t('menuOrganization.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranchValue" :clearable="false"
                              :options="organizationBranchOptions" :reduce="item => item.value">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full" v-model="keySearch" :placeholder="$t('button.search')"
                              v-on:keyup.enter="filter"/>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full w-full mt-4">
                    <vs-button @click="filter" color="primary" icon-pack="feather" icon="icon-search"
                               class="mr-2 lg:mt-6">
                        Tìm kiếm
                    </vs-button>
                </div>
            </div>
            <div class="flex items-center mt-5">
                <div class="flex flex-wrap ">
                    <vs-button @click="addEmployee" color="primary" icon-pack="feather" icon="icon-plus"
                               class="mr-2 mt-2" v-if="isPermissionAddEmployee">
                        {{ $t('button.addEmployee') }}
                    </vs-button>
                    <vs-button @click="downloadTemplate" color="primary" icon-pack="feather" icon="icon-download"
                               class="mr-2 mt-2" v-if="selectedOrganizationBranchValue">
                        Tải xuống tệp mẫu
                    </vs-button>
                    <vs-button @click="$refs.fileUpload.click()" color="primary" icon-pack="feather" icon="icon-upload"
                               class="mt-2" v-if="selectedOrganizationBranchValue">
                        Tải lên tệp nhân viên
                    </vs-button>
                    <input ref="fileUpload" type="file" id="fileUpload" accept=".xlsx, .xls, .csv, .xlsm, .xlsb"
                           class="hidden" @change="uploadFile($event)">
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="employeeData"
                         :animateRows="true"
                         :pagination="true"
                         :localeText="  {noRowsToShow: this.$t('menuCustomer.noRowsToShow')} "
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="vx-row" v-if="employeeData.length > 0">
                <div class="vx-col md:w-1/2">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                        <span class="vx-col mt-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        employeeData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : employeeData.length
                                    }} /
                                    {{ totalElements }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="changePageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(30)">
                                    <span>30</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(50)">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="changePageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
                </div>
            </div>
        </div>

        <vs-popup class="holamundo popupError" title="Lỗi tải lên tệp nhân viên" :active.sync="popupErrorImport">
            <div class="">
                <div>
                    <vs-table stripe :data="errorData" pagination max-items="10">
                        <template slot="thead">
                            <vs-th> STT</vs-th>
                            <vs-th> Trường dữ liệu</vs-th>
                            <vs-th> Hàng</vs-th>
                            <vs-th> Cột</vs-th>
                            <vs-th> Lỗi</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(item, indextr) in data">
                                <vs-td> {{ item.stt }}</vs-td>

                                <vs-td> {{ item.header }}</vs-td>

                                <vs-td> {{ item.rowNumError }}</vs-td>

                                <vs-td> {{ item.colChar }}</vs-td>

                                <vs-td> {{ item.message }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../../ui-elements/Pagination.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";
import authConfig from '@/../auth_config.json';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererStatus,
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            keySearch: null,
            checkEmployee: true,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuOrganization.employeeCode'),
                    field: 'employeeCode',
                    width: 100
                },
                {
                    headerName: this.$t('menuOrganization.employeeName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('menuOrganization.address'),
                    field: 'fullAddress',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.phoneNumber'),
                    field: 'phoneNumber',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'enabledString',
                    cellRendererFramework: 'CellRendererStatus',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 150,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            employeeData: [],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            userInfo: null,
            popupErrorImport: false,
            errorData: [],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            client: null,
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateEmployee'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_EMPLOYEE', false);
            }
        }
    },
    computed: {
        // selectedOrganizationBranch: {
        //     get() {
        //         return {
        //             label: this.organizationBranchString(this.selectedOrganizationBranchValue),
        //             value: this.selectedOrganizationBranchValue
        //         }
        //     },
        //     set(obj) {
        //         this.selectedOrganizationBranchValue = obj.value
        //         this.loadAllEmployee()
        //     }
        // }
    },
    methods: {
        isPermissionAddEmployee() {
            return isAPI(this, constAPI.employee_add);
        },
        // isPermissionUpdateAI() {
        //     return isRouter(this, constRouter.employee_edit)
        // },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        downloadTemplate() {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.$vs.loading();
            this.$crm.post(`/employee/download-template/${userInfo.organization.id}/${this.selectedOrganizationBranchValue}`).then(res => {
                window.open(authConfig.crmDomain + "file/beauty/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        isExcel(file) {
            return /\.(xlsx)$/.test(file.name)
        },
        uploadFile(e) {
            let file = [...e.target.files];
            if (!this.isExcel(file[0])) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .xlsx!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let checkBranch = file[0].name.split('-')[1];
            if (parseInt(checkBranch) !== this.selectedOrganizationBranchValue) {
                this.$refs.fileUpload.value = null;
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Tệp tải lên phải cùng chi nhánh với chi nhánh đang chọn!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }

            let formData = new FormData();
            formData.append('file', file[0]);
            this.errorData = [];
            this.$vs.loading();
            this.$crm.post(`/employee/import-excel-employee/${this.selectedOrganizationBranchValue}`, formData).then(res => {
                if (res.data && res.data.length > 0) {
                    this.popupErrorImport = true;
                    this.errorData = res.data.map(el => {
                        el.stt = res.data.indexOf(el) + 1;
                        return el;
                    });
                } else {
                    this.$vs.notify({
                        text: 'Tải lên tệp nhân sự thành công!',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    });
                    this.loadAllEmployee();
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
            this.$refs.fileUpload.value = null;
        },
        addEmployee() {
            if (this.organizationBranchOptions.length === 0 && !this.selectedOrganizationBranchValue) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('button.addEmployee'),
                    text: `Chưa có chi nhánh nào, vui lòng thêm chi nhánh trước.`,
                    accept: this.acceptGoToAddBranch,
                    acceptText: this.$t('button.agree'),
                    cancelText: this.$t('button.cancel')
                })
                return;
            }
            if (this.selectedOrganizationBranchValue == null) {
                // let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                // this.selectedOrganizationBranchValue = userInfo.organization.id
                this.selectedOrganizationBranchValue = this.organizationBranchOptions[1].value
                this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
            if (this.selectedOrganizationBranchValue) {
                this.$router.push(`/user/add-employee?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
                });
            }
        },
        acceptGoToAddBranch() {
            this.$router.push(`/user/add-organization-branch`).catch(() => {
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                this.$vs.notify({
                    text: 'Danh sách chi nhánh trống!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuOrganization.all')})

            let branchId = this.$route.query.branch_id;
            if (branchId) this.selectedOrganizationBranchValue = parseInt(branchId, 10);
            this.filter();
        },

        loadAllEmployee() {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
            this.employeeData = [];
            this.$vs.loading();
            let payload = {
                // enabled: null,
                organizationBranchId: this.selectedOrganizationBranchValue,
                organizationId: this.userInfo.organization.id,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                sort: 'modifiedDate',
                keySearch: this.keySearch,
            }
            this.$crm.post('/employee/find-by-condition', payload).then((response) => {
                if (response.data.content && response.data.content.length > 0) {
                    response.data.content.forEach(x => {
                        if (x.enabled) {
                            x.enabledString = this.$t('employeeStatus.working');
                        } else {
                            x.enabledString = this.$t('employeeStatus.offWork');
                        }
                    });
                    this.employeeData = response.data.content;
                    this.employeeData.sort((a, b) => b.id - a.id)
                }
                this.totalPages = response.data.totalPages;
                this.totalElements = response.data.totalElements;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.loadAllEmployee();
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.loadAllEmployee();
            }
        },

        filter() {
            this.currentPage = 1;
            this.pageNumber = 0;
            this.loadAllEmployee();
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
